import { Grid, GridColumn } from '@progress/kendo-react-grid';
import React from 'react'
import { useState } from 'react'
import { useTranslation } from '../../locale/useTranslation';
import { useEffect } from 'react';
import { CheckboxCell } from '../../framework/forms/helpercomponents/CustomGridCells/CheckBoxCell';
import { CellRender, RowRender } from '../Segment/renderers';
import { EditPageHeader } from '../../components/EditPageHeader';
import { myTimeCell } from '../../framework/forms/helpercomponents/inline grid cell/MyTimeCell';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import { toast } from 'react-toastify';
import BossDialog from '../../components/BossDialog';
import { TimeRangePicker } from '../../framework/forms/helpercomponents/timepicker/TimeRangePicker';

const MyNumericCell = (props) => {
    const isPlayViaPlayCount = props.dataItem.PlayViaPlayCount

    const onChange = (e) => {
        if (props.onChange) {
            props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: field,
                syntheticEvent: e.syntheticEvent,
                // value: field = 'Weight' ? e.target.value : isPlayViaPlayCount && field == 'PlayCount' ? e.target.value : 0,
                value : e.target.value
            });
        }
    };

    const field = props.field || "";
    const dataValue = props.dataItem[field] === null ? '' : props.dataItem[field]; 
    

    return <td> 
        {field == 'Weightage' && !isPlayViaPlayCount ? <NumericTextBox name={field} value={dataValue} onChange={onChange} min={0} max = {100} /> : 
        isPlayViaPlayCount ? <NumericTextBox name={field} value={dataValue} onChange={onChange} min={0} /> : 0}
    </td>
};

const AutoPlotPromo = (props) => {
    const EDIT_FIELD = 'inEdit';
    const [data, setData] = useState([]);

    const lang = useTranslation();

    useEffect(() => {
        setData(props.data);
    }, [])

    const enterEdit = (dataItem, field) => {
        const newData = data.map(item => ({
            ...item,
            [EDIT_FIELD]: item._id === dataItem._id ? field : undefined
        }));
        console.log(dataItem);
        setData(newData);
    };

    const exitEdit = () => {
        const newData = data.map(item => ({
            ...item,
            [EDIT_FIELD]: undefined
        }));
        setData(newData);
    };

    const itemChange = event => {

        let field = event.field || '';
        event.dataItem[field] = event.value;

        let newData = data.map(item => {
            if (item._id === event.dataItem._id) {
                item[field] = event.value;
            }

            return item;
        });

        console.log(newData)

        setData(newData);
        props.setData(newData);
    };

    const MyTimeRangeEditCell = (props) => {

        const field = props.field || "";

        const onChange = (e) => {
    
            if (props.onChange) {
                props.onChange({
                    dataIndex: 0,
                    dataItem: props.dataItem,
                    field: field,
                    syntheticEvent: e.syntheticEvent,
                    value: e.target.value,
                });
    
            }
        };
    
        const style = {
            textAlign: 'center'
        };

        console.log(props.dataItem[field])
    
        return <td style={style}><TimeRangePicker name={field} value={props.dataItem[field]} onChange={onChange} /></td>
    };

    const customCellRender = (td, props) => <CellRender originalProps={props} td={td} enterEdit={enterEdit} editField={EDIT_FIELD} />;
    const customRowRender = (tr, props) => <RowRender originalProps={props} tr={tr} exitEdit={exitEdit} editField={EDIT_FIELD} />;
    const MyCheckBoxCell = (props) => <CheckboxCell {...props} disable={false}/>;

    const handleSubmit = () => {
        //VALIDATION 
        if(data.some((x) => x.Weightage > 100)){
            toast.error("Weightage should be less than or equal to 100", {
                position: toast.POSITION.TOP_RIGHT,
            });
            return;
        }
        props.onSave();
    }

    return (
        <>
        <BossDialog
            title={`Auto Plot Promo`}
            onClose={props.cancelEdit}
            width={"60%"}
        >
        <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false}/>
        <Grid data={data} resizable={true} style={{ height: "30vh" }} dataItemKey={'_id'} onItemChange={itemChange} cellRender={customCellRender} rowRender={customRowRender} editField={EDIT_FIELD}>
            <GridColumn field="Name" title={lang.name_column} width={'180px'} editable={false}/>
            <GridColumn field="DayPart.Description" width={'200px'} title={'Day Part'} editable={false}/>
            <GridColumn field="From" width={'80px'} title={lang.from_column} editable={true} cell={MyTimeRangeEditCell}/>
            <GridColumn field="To" width={'80px'} title={lang.to_column} editable={true} cell={MyTimeRangeEditCell}/>
            <GridColumn field="Weightage" title={'Weightage'} width={'120px'} editor='numercic' cell = {MyNumericCell}/>
            <GridColumn field="PlayCount" title={'Play Count'} width={'120px'} editor='numercic' cell = {MyNumericCell} />
            <GridColumn field="PlayViaPlayCount" title={'Play Via Count'} width={'120px'} editor="boolean" cell={MyCheckBoxCell} />
        </Grid>
        </BossDialog>
    </>
    )
}

export default AutoPlotPromo